import { GameState } from '@/context/JackpotProvider'
import { getGroupedPlayers } from '@/helpers/getGroupedPlayers'
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  Text,
  Flex,
  Box,
  Button,
  ModalCloseButton,
} from '@chakra-ui/react'
import { GameParticipants } from '@/components/molecules/GameParticipants/GameParticipants'
import { JACKPOT_FEE, SHU_DENOM } from '@/constants/constants'
import { useTranslation } from 'next-i18next/pages'
import CrownIcon from '@/public/assets/icons/crown.svg'
import { FiatOrCryptoAmount } from '@/components/atoms/Amount/Amount'
import { getTokenByDenom } from '@/services/token-service'
import { TokenMoney } from '@ninjablaze/sdk-ts'

export default ({ onClose, roundData }: { onClose: () => void; roundData: GameState }) => {
  const { t } = useTranslation()
  const groupedPlayers = getGroupedPlayers(roundData.players, roundData.pool)

  return (
    <Modal size={'xs'} isOpen={true} onClose={onClose}>
      <ModalOverlay />
      <ModalContent marginLeft={2.5} marginRight={2.5}>
        <ModalCloseButton />
        <ModalHeader pb={4}>
          <Text fontSize="xl" fontWeight="700">
            {t('common.congrats')}!
          </Text>
        </ModalHeader>
        <ModalBody pb={5}>
          <Flex justifyContent={'center'} pos={'relative'}>
            <Flex
              pos={'absolute'}
              left={'50%'}
              transform={'translateX(-50%)'}
              top={'-12px'}
              rounded={'full'}
              bg={'ninja.500'}
              w={6}
              h={6}
              justifyContent={'center'}
              alignItems={'center'}
              color={'ninja.700'}
            >
              <CrownIcon />
            </Flex>
            <Flex
              rounded={'2xl'}
              alignItems={'center'}
              justifyContent={'center'}
              flexDir={'column'}
              mb={3}
              py={4}
              px={6}
              border={'2px'}
              borderColor={'ninja.500'}
            >
              <Box mb={2}>{getTokenByDenom(SHU_DENOM)?.icon(5)}</Box>
              <Label>{t('Jackpot.your-reward')}</Label>
              <FiatOrCryptoAmount
                iconStyles={{
                  display: 'none',
                }}
                wrapperStyles={{
                  fontSize: 'xl',
                  fontWeight: 700,
                }}
                value={new TokenMoney(roundData.win_amount, SHU_DENOM)}
              />
            </Flex>
          </Flex>
          <Flex justifyContent={'space-between'} gap={2} mb={1}>
            <Box flexBasis={'100%'} py={2} px={3} bg={'ninja.700'} rounded={'xl'}>
              <Label>{t('common.your-bet')}</Label>
              <FiatOrCryptoAmount
                iconSize={'18px'}
                wrapperStyles={{
                  fontWeight: 700,
                }}
                value={
                  new TokenMoney(groupedPlayers.find((x) => x.address === roundData.player_winner)?.amount!, SHU_DENOM)
                }
              />
            </Box>
            <Box bg={'ninja.700'} py={2} px={3} pr={6} rounded={'xl'}>
              <Label>{t('Jackpot.chance')}</Label>
              <Text fontWeight={700}>{groupedPlayers.find((x) => x.address === roundData.player_winner)?.chance}%</Text>
            </Box>
          </Flex>
          <Flex px={2} fontSize={'xs'} color={'ninja.200'} justifyContent={'space-between'} mb={2}>
            <Text> {t('common.fee')}:</Text>
            <Text>{JACKPOT_FEE * 100}%</Text>
          </Flex>
          <Text textAlign={'center'} fontWeight={700} fontSize={'sm'} color={'ninja.200'} mb={2}>
            {t('common.opponents')}
          </Text>
          <Flex justifyContent={'center'}>
            <GameParticipants
              size="sm"
              players={roundData.players.map((player) => player.address)}
              winner={roundData.player_winner!}
            />
          </Flex>
          <Button mt={5} w={'full'} rounded={'2xl'} onClick={onClose}>
            {t('common.done')}
          </Button>
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

const Label = ({ children }: { children: string }) => (
  <Text mb={0.5} fontSize={'xs'} fontWeight={700} color={'ninja.200'}>
    {children}
  </Text>
)
